import { useState } from 'react';
import apiService from '../../axios/apiService';

export const useUsersDropdownList = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);

  const getUsersList = async (params) => {
    // Fetch users list
    try {
      setLoading(true);
      const list = await apiService.getAllClinicUserDropdownList(params);
    list.items = list?.items?.map((item) => ({
      label: item.email,
      value: item.email,
      description: item.description,
    }));
      list && setData(list); // update data state
      return list;
    } catch (error) {
      return {
        items: [],
      };
    } finally {
      setLoading(false);
    }
  };

  return {
    data,
    getUsersList,
    loading,
  };
};
